import { ActivityType } from 'app/constants/activity'

export const getActivityHeight = (type) => {
  let factor = 1

  switch (type) {
    case ActivityType.AVAILABILITY:
      factor = 0.7
      break
    case ActivityType.WORK:
      factor = 0.8
      break
    case ActivityType.DRIVING:
      factor = 0.6
      break
    case ActivityType.REST:
      factor = 1
      break
    case ActivityType.UNKNOWN:
      factor = 1
      break
  }

  return factor
}
